import httpRequest from '../../utils/httpRequest'

export const SET_ORDERBOOK = 'SET_ORDERBOOK'

export const setOrderBook = data => dispatch => dispatch({ type: SET_ORDERBOOK, data })

export const getDepth = params => async dispatch => {
  try {
    const depth = await httpRequest.getDepth(params)
    depth.symbol = params.symbol
    dispatch(setOrderBook(depth))
  } catch (err) {
    console.log(`status:${err.status} message: ${err.statusText}`)
  }
}
